export default __webpack_public_path__ + "static/prismicLogo-b7f7178fe1d19c4ce952577bbd97bfb2.png";